home.topTipsModule = {
    // Funkcia na ziskanie id-ciek top eventov a ich pridanie na tiket
    createTopTicket: function() {
        try {
            main.userAction();
            if (more.asideLoading.inProgress) return; // Kontrola ci nie je spustene nejake schvalovanie tiketu

            var topTicketOdds = [];

            // Pocas pridavania oddov zamkne tiket, tlacitko Submit ticketa Clear ticket
            main.lockSbmButtons();
            try {
                dataTemp = new Object();
                dataTemp.Odds = [];
                nextGroup = "A";
                if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT) && $("#ticketList li").length) {
                    nextGroup = String.fromCharCode($("#ticketList .group-name:last").text().charCodeAt(0) + 1);
                }
                // Pridanie oddov na tiket
                if (cache && cache["EventsOfDay"] && cache["EventsOfDay"].data && cache["EventsOfDay"].data.TopEvents) {
                    var oddsList = [];

                    // Vyfiltruje oddy ktore niesu na tikete
                    cache["EventsOfDay"].data.TopEvents.filter(function(te) {
                        if (list.Odds.indexOf(te.TopOddsID) === -1) {
                            return te.TopOddsID;
                        }
                    }).forEach(function(topEventOdd) {
                            var isLiveOdd = false;
                            if (topEventOdd.LiveBetting === "Y") {
                                isLiveOdd = true;
                            }
                            // Vytvori objekt oddov
                            var oddToPush = JSON.parse('{"OddID":"' + topEventOdd.TopOddsID
                            + '", "SportID":"' + topEventOdd.SportID
                            + '", "SportName":"' + topEventOdd.SportName
                            + '", "RegionName":"' + topEventOdd.RegionName
                            + '", "LeagueCupName":"' + topEventOdd.LeagueCupName
                            + '", "Team1":"' + topEventOdd.team1
                            + '", "Team2":"' + topEventOdd.team2
                            + '", "ChanceType":"' + topEventOdd.ChanceTypeName
                            + '", "EVT":"' + topEventOdd.EventID
                            + '", "DATE":"' + topEventOdd.date + ' ' + topEventOdd.time
                            + '", "Tip":"' + topEventOdd.topTipName
                            + '", "Rate":' + topEventOdd['Rate_' + topEventOdd.TopTip]
                            + ', "LiveBet":' + isLiveOdd
                            + ', "IsActive":' + true
                            + ', "Group":"' + nextGroup + '"}');
                            if (ticket.state.isTicketWsType(ticket.state.ticketWsTypes.SRT)) {
                                nextGroup = String.fromCharCode(nextGroup.charCodeAt(0) + 1);
                            }
                            dataTemp.Odds.push(oddToPush);
                            // Ulozi odd do listu
                            oddsList.push(topEventOdd.TopOddsID);
                    });
                    if (!oddsList.length) {
                        events.unlockEvent();
                        return false;
                    }
                    list.Sync++;
                    $("#eventsOfDay .event-of-day").find("a").removeClass("ui-btn-up-e");

                    // Vyrenderuje oddy na tikete
                    ticket.ticket(dataTemp, null);
                }
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            }
            // Synchronizuje so serverom
            modal.showLoading();
            try {
                var requestUrl;
                $.getJSON(requestUrl = url.ticket + "ticket/SBID_" + stored.SBID + "/oddaddlist/" + oddsList.join() + "/" + ticket.ticketOddModule.setLogOdd())
                    .done(function (data) {
                        if (data === Object(data)) {
                            ticket.ticketOddModule.ctAddOddDone(true, oddsList, data, true);
                        } else {
                            // NO DATA -> TICKET RETRIEVE | CLEAR | RESET
                            main.createLog(2, "CentralTicketAddOddList_Failed", "ODDs: " + oddsList.join());
                            ticket.ticketWsRetrieve(true);
                        }
                    })
                    // Ak addOdd zlyha pri sync tak sa da rollback
                    .fail(function (jqXHR) {
                        jqXHR.requestUrl = requestUrl;
                        main.createLog(2, "CentralTicketAddOddList_Failed", "ODDs: " + topTicketOdds.join() + " # AJAX FAILED: " + JSON.stringify(jqXHR));
                        ticket.ticketWsRetrieve(true);
                    })
                    .always(function (data) {
                        events.unlockEvent();
                        // Zobrazi pripadne error hlasky
                        if (data) {
                            var errors = modal.parseErrors(data.Errors, data.MaxBetReason);
                            modal.showErrObj(2, 5, {errObj: errors});
                        }
                    });
            } catch (e) {
                console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
                events.unlockEvent();
            }

            // Ak nebezi refresh tiketu tak schova napovedu
            if (!rfs.ticket && list.Odds.length) {
                $("#ticketHelp").hide();
                ticket.stopMarkingHelp();
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ticket.ticketWsRetrieve(true);
            events.unlockEvent();
            return true;
        }
    }
};
